import { useCampaignPerformanceEnabled } from '@/features/campaignPerformance';
import { useComuniEnabled } from '@/features/comuni';
import { workspaceSectionAccess } from '@/features/layout/workspaceSectionAccess';
import { useMarketIntelligenceEnabled } from '@/features/marketIntelligence';
import RouteConstants from '@/features/router/RouteConstants';
import { NavSidebarItemData } from '../components/SidebarBase/SidebarNavigation/Items/NavSidebarItem/types';
import { SIDEBAR_CONFIG } from '../constants';

type SidebarFlags = {
  campaignPerformance: boolean;
  comuni: boolean;
  marketIntelligence: boolean;
};

/** Sidebar entries, minus the ones whose feature flag is off. */
export const visibleSidebarItems = (flags: SidebarFlags): ReadonlyArray<NavSidebarItemData> => {
  const access = workspaceSectionAccess(flags);
  const items = SIDEBAR_CONFIG.filter((item) => {
    if (item.path === RouteConstants.campaignPerformance) return flags.campaignPerformance;
    if (item.path === RouteConstants.comuni) return access.comuni;
    if (item.path === RouteConstants.marketIntellingence) return access.marketIntelligence;
    return true;
  });

  if (!access.comuni) return items;

  const comuniItem = items.find((item) => item.path === RouteConstants.comuni);
  const withoutComuni = items.filter((item) => item.path !== RouteConstants.comuni);
  const homeIndex = withoutComuni.findIndex((item) => item.path === RouteConstants.home);
  const insertAt = homeIndex === -1 ? 0 : homeIndex + 1;

  return [...withoutComuni.slice(0, insertAt), ...(comuniItem ? [comuniItem] : []), ...withoutComuni.slice(insertAt)];
};

export const useSidebarItems = (): ReadonlyArray<NavSidebarItemData> =>
  visibleSidebarItems({
    campaignPerformance: useCampaignPerformanceEnabled(),
    comuni: useComuniEnabled(),
    marketIntelligence: useMarketIntelligenceEnabled(),
  });
